import styled from '@emotion/styled';

export const FormLabel = styled.p`
  font-size: 16px;
  margin-bottom: ${props => props.theme.spacing.xs};
`;
